/**
 * OneSignal User Setup - Sets up user ID and tags after OneSignal is initialized
 */

import OneSignal from 'onesignal-cordova-plugin';
import { buildConferenceTags } from './onesignal-tags';

/**
 * Sets up OneSignal user ID and tags
 * This should be called AFTER OneSignal.initialize()
 * @param {Object} userData - User profile data from the API
 */
export async function setupOneSignalUser(userData) {
  try {
    // Prepare user properties
    const userProps = {
      delegateName: userData.name,
      teamID: userData.groupName,
      userType: userData.userType,
      delegateType: userData.organization === 'Heart of God Church' ? 'Host' : 'Delegate',
    };

    if (userData.tracking) {
      userProps.delegateEmail = userData.email;
      userProps.churchName = userData.organization;
    }

    // Login user with OneSignal
    const oneSignalUserId = 'GPC-' + userData.id;
    await OneSignal.login(oneSignalUserId);

    // Build conference tags
    const conferenceTags =
      userData.conferences && Array.isArray(userData.conferences) && userData.conferences.length > 0
        ? buildConferenceTags(userData.conferences)
        : {};

    // Combine all tags
    const allTags = {
      confYear: userData.confYear,
      ...userProps,
      ...conferenceTags,
    };

    // Remove deprecated year tag (GIC3 cleanup deferred to next phase)
    await OneSignal.User.removeTags(['year']);

    // Add tags to OneSignal
    await OneSignal.User.addTags(allTags);
    return true;
  } catch (error) {
    console.error('[OneSignal] Setup error:', error);
    return false;
  }
}
